module.exports = __webpack_public_path__ + "img/guide1-2.3ba12194.png";